<div class="d-flex">
    <div class="reports-menu">
        <ul class="root pl-0">
            <mat-accordion>
                @for (item of tree(); track item.id) {
                    @if (item.name === '') {
                        <mat-expansion-panel [expanded]="selectedGroup() === ''">
                            <mat-expansion-panel-header>
                                <mat-panel-title>{{ 'General.General' | translate }}</mat-panel-title>
                            </mat-expansion-panel-header>
                            <ng-container *ngTemplateOutlet="reportLinkTpl" />
                        </mat-expansion-panel>
                    } @else {
                        <mat-expansion-panel [expanded]="selectedGroup() === item.name">
                            <mat-expansion-panel-header>
                                <mat-panel-title>{{ item.name }}</mat-panel-title>
                            </mat-expansion-panel-header>
                            <ul class="group pl-0">
                                <ng-container *ngTemplateOutlet="reportLinkTpl" />
                            </ul>
                        </mat-expansion-panel>
                    }

                    <ng-template #reportLinkTpl>
                        @for (subItem of item.children; track subItem.id) {
                            <li>
                                <button mat-button (click)="loadReport(subItem.id)">{{ subItem.name }}</button>
                            </li>
                        }
                    </ng-template>
                }
            </mat-accordion>
        </ul>
    </div>
    <div class="report-card flex-fill">
        @if (reportUrl()) {
            <mat-card appearance="outlined" class="mat-elevation-z4">
                <mat-card-header>
                    <mat-card-title>{{ 'Report.Report' | translate }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="report-wrapper">
                        @if (!isReportLoaded()) {
                            <div class="center-loader">
                                <div class="spinner-wrapper">
                                    <mat-spinner />
                                </div>
                            </div>
                        }

                        <iframe
                            width="100%"
                            height="1280px"
                            [src]="reportUrl() | safeUrl"
                            style="display: flex"
                            (load)="isReportLoaded.set(true)"></iframe>
                    </div>
                </mat-card-content>
            </mat-card>
        }
    </div>
</div>
